import { useTrackersData } from 'pages/Trackers/trackersProvider';
import PropTypes from 'prop-types';
import React, { useMemo } from 'react';
import { stepType } from 'utils/reactFlowUtils';

import { useStepStatus } from './node';
import ProgressCircle from './progressCircle';
import ShippingDate from './shippingDate';

export default function CollapsedListView({ projectId, treesData, expandTo }) {
  const { groupedOrdersByProject } = useTrackersData();
  const { lineItemsMap } = groupedOrdersByProject[projectId];

  const shipments = useMemo(() => {
    const result = {};

    const finalSteps = treesData.flat(2).filter((step) => step.isShippingPoint);
    finalSteps.forEach((step) => {
      const lineItem = lineItemsMap[step.lineItemId];
      if (result[lineItem.shipDateActual]) {
        result[lineItem.shipDateActual].steps.push(step);
      } else {
        result[lineItem.shipDateActual] = {
          shipDateActual: lineItem.shipDateActual,
          shipDateTarget: lineItem.shipDateTarget,
          shipDateBusinessDays: lineItem.shipDateBusinessDays,
          steps: [step],
        };
      }
    });

    return Object.values(result);
  }, [lineItemsMap, treesData]);

  return shipments.length > 0
    ? (
      <ul className="collapsedListView">
        {shipments.map((shipment) => (
          <li className="shipment" key={`${projectId}-${shipment.shipDateActual}`}>
            <ShippingDate
              shipDateTarget={shipment.shipDateTarget}
              shipDateActual={shipment.shipDateActual}
              shipDateBusinessDays={shipment.shipDateBusinessDays}
              isInternal={projectId.startsWith('P')}
            />
            <ul className="lineItems">
              {shipment.steps.map((step, idx) => (
                <ListStepStatus
                  // eslint-disable-next-line react/no-array-index-key
                  key={`${step.pPartId}-${idx}`}
                  step={step}
                  expandTo={expandTo}
                />
              ))}
            </ul>
          </li>
        ))}
      </ul>
    ) : (
      <p className="emptyCollapsedView">No shipments</p>
    );
}

CollapsedListView.propTypes = {
  projectId: PropTypes.string.isRequired,
  treesData: PropTypes.arrayOf(PropTypes.arrayOf(
    PropTypes.arrayOf(stepType),
  )).isRequired,
  expandTo: PropTypes.func.isRequired,
};

function ListStepStatus({ step, expandTo }) {
  const { projectStatus, queryStatus } = useStepStatus(step);

  return (
    <li>
      <button
        className="lineItem"
        type="button"
        onClick={() => expandTo(step.uniqueId)}
      >
        <span className="badge finalLineItem">
          {step.pPartId || step.lineItemId}
        </span>
        <span className="progress">
          <span className="passed">
            {queryStatus === 'success' ? projectStatus.passed : '-'}
          </span>
          /
          {step.goal}
        </span>
        <ProgressCircle
          passed={queryStatus === 'success' ? projectStatus.passed : 0}
          goal={step.goal}
        />
      </button>
    </li>
  );
}

ListStepStatus.propTypes = {
  step: stepType.isRequired,
  expandTo: PropTypes.func.isRequired,
};
